/**
 * Application configuration loaded from environment variables.
 *
 * Environment variables should be prefixed with VITE_ to be exposed to the client.
 *
 * Available variables:
 * - VITE_SESSION_WARNING_SECONDS: Countdown seconds before auto-logout (default: 30)
 * - VITE_SESSION_CHECK_INTERVAL_SECONDS: How often to validate the session (default: 60)
 */

function parseIntEnv(key: string, defaultValue: number): number {
  const value = import.meta.env[key];
  if (value === undefined || value === "") {
    return defaultValue;
  }
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
}

// Platform version - TODO: fetch from API
export const PLATFORM_VERSION = "0.1.0";

export const appConfig = {
  session: {
    /** Number of seconds to show the warning countdown before auto-logout */
    warningSeconds: parseIntEnv("VITE_SESSION_WARNING_SECONDS", 30),
    /** How often to check if the session is still valid (in seconds) */
    checkIntervalSeconds: parseIntEnv("VITE_SESSION_CHECK_INTERVAL_SECONDS", 60),
  },
} as const;
